import React from 'react';
import { Radio } from 'antd';

import { theme } from '../../../../styles';

import {
  Input,
  SvgIcon,
  isTinyMobile,
} from '../../ui-helpers';

import {
  SYMBOLS,
  getFontCssClass,
} from './helpers';

import {
  ItemContainer,
  Title,
  Symbols,
  StyledRadioGroup,
  FontTitleContainer,
} from './Engraving-styled';


interface Props {
  engravingText:string,
  onEngravingTextChange:(value:string)=>void,

  engravingFont:'Brush Script'|'Century Gothic'|'Snell Roundhand'|'Trajan'|'Dakota',
  engravingFontOptions:('Brush Script'|'Century Gothic'|'Snell Roundhand'|'Trajan'|'Dakota')[]
  onEngravingFontChange:(value:string)=>void
}

interface State {
  engravingTextInput:string,
}

export default class extends React.Component<Props,State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      engravingTextInput: '',
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onSymbolSelect = this.onSymbolSelect.bind(this);
  }

  componentDidMount() {
    const {
      engravingText,
    } = this.props;

    this.setState({
      engravingTextInput: engravingText
    })
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.engravingText !== this.props.engravingText) {
      this.setState({
        engravingTextInput: this.props.engravingText
      })
    }
  }

  onInputChange = (value: string) => {
    this.setState({
      engravingTextInput: value,
    }, () => this.props.onEngravingTextChange(value));
  };

  onSymbolSelect = (value: string) => {
    document.getElementById('engraving-text-input').focus();
    this.setState({
      engravingTextInput: this.state.engravingTextInput.concat(value)
    }, () => this.props.onEngravingTextChange(this.state.engravingTextInput));
  };

  render() {
    const {
      engravingFont,
      onEngravingFontChange,
    } = this.props;

    const {
      engravingTextInput
    } = this.state;
    const tinyMobile = isTinyMobile();

    return (
      <div className="threed-configurator-menu-engraving-tab">
        <ItemContainer className="threed-configurator-menu-item-container">
          <Title>Text</Title>
          <Input
            value={engravingTextInput}
            placeholder="Text on the Ring..."
            onChange={this.onInputChange}
            className={getFontCssClass(engravingFont)}
          />
        </ItemContainer>

        <ItemContainer className="threed-configurator-menu-item-container">
          <Title>Symbols</Title>
          <Symbols>
            <SvgIcon
              type="heart"
              style={{
                width: '8%',
                height: 'auto',
                fill: 'inherit',
              }}
              onClick={() => this.onSymbolSelect(SYMBOLS.heart)}
            />
            <SvgIcon
              type="hearts"
              style={{
                width: '10%',
                height: 'auto',
                fill: 'inherit',
              }}
              onClick={() => this.onSymbolSelect(SYMBOLS.couple)}
            />
            <SvgIcon
              type="infinity"
              style={{
                color: 'inherit',
              }}
              onClick={() => this.onSymbolSelect(SYMBOLS.infinity)}
            />
          </Symbols>
        </ItemContainer>

        <FontTitleContainer>
          <Title style={{ marginBottom: 'unset' }}>Font</Title>
        </FontTitleContainer>

        <ItemContainer className="threed-configurator-menu-item-container" style={{ border: 'unset' }}>
          <StyledRadioGroup
            value={engravingFont}
            defaultValue={engravingFont}
            onChange={(e) => onEngravingFontChange(e.target.value)}
          >
            {
              this.props.engravingFontOptions.map((font, index) => (<Radio
                  value={font}
                  key={font}
                >
                  <span style={{ display: 'flex' }}>
                    <span style={{ width: '20px' }}>{index+1}</span>
                    <span className={getFontCssClass(font)}>
                      {!tinyMobile ? 'Michael & Jessica 28-5-2014' : 'Micha & Jess 2014'}
                    </span>
                  </span>
              </Radio>
              ))
            }
          </StyledRadioGroup>
        </ItemContainer>
      </div>
    )
  }
};
